import { ref, set, onValue, get, child, off } from "firebase/database";
import { useState, useEffect } from "react";
import SessionCard from "../components/SessionCard";
import { v4 as uuidv4 } from "uuid";
import Task from "../components/Task";
import {
  Text,
  Box,
  HStack,
  VStack,
  FormControl,
  FormErrorMessage,
  Input,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Grid,
} from "@chakra-ui/react";

function Home({ user, uid, db }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [sessions, setSessions] = useState(null);
  const [input, setInput] = useState("");
  const [inCompleteTasks, setInCompleteTasks] = useState(null);
  const [isInvalid, setIsInvalid] = useState(false);
  const taskList = {};

  useEffect(() => {
    const sessionsRef = ref(db, "sessions");
    onValue(sessionsRef, (snapshot) => {
      const data = snapshot.val();
      console.log(data);
      setSessions(data);
    });

    return () => {
      off(sessionsRef);
    };
  }, [db]);

  const handleClose = (e) => {
    onClose();
    taskList.length = 0;
  };

  const closeModal = (e) => {
    e.preventDefault();
    onClose();
    console.log(taskList);
    const sessionId = uuidv4();
    set(ref(db, "sessions/" + sessionId), {
      active: true,
      name: input,
      users: [uid],
      usernames: [user.displayName],
      userPictures: [user.photoURL],
      tasks: {
        [uid]: Object.values(taskList).map((task) => ({
          name: task,
          done: false,
        })),
      },
    });
    set(ref(db, "users/" + uid + "/session"), sessionId);
  };

  const updateTaskList = (id, val, taskName) => {
    if (val) {
      taskList[id] = taskName;
    } else {
      delete taskList[id];
    }
  };

  const newSession = async (e) => {
    e.preventDefault();
    console.log("New session");

    if (input === "") {
      setIsInvalid(true);
    } else {
      const dbRef = ref(db);
      const snapshot = await get(child(dbRef, `users/${uid}/lastSession`));
      if (snapshot.exists()) {
        console.log("Exists");
        const snapshotTasks = await get(
          child(dbRef, `sessions/${snapshot.val()}/tasks/${uid}`)
        );
        if (snapshotTasks.exists()) {
          console.log("Tasks exist");
          const inCompleteTasks = Object.values(snapshotTasks.val()).filter(
            (task) => !task.done
          );
          if (inCompleteTasks.length > 0) {
            console.log("Incomplete tasks");
            setInCompleteTasks(inCompleteTasks);
            onOpen();
            return;
          }
        }
      }

      console.log("rip");
      const sessionId = uuidv4();
      set(ref(db, "sessions/" + sessionId), {
        active: true,
        name: input,
        users: [uid],
        usernames: [user.displayName],
        userPictures: [user.photoURL],
      });
      set(ref(db, "users/" + uid + "/session"), sessionId);
    }
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
    if (e.target.value !== "") {
      setIsInvalid(false);
    }
  };

  return (
    <Box px={6} py={4}>
      <Modal key="a" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Which uncompleted tasks which you like to carry over from the
            previous session?
          </ModalHeader>
          <ModalBody>
            <VStack alignItems="flex-start">
              {inCompleteTasks
                ? inCompleteTasks.map((task, index) => (
                    <Task
                      key={index}
                      id={index}
                      name={task.name}
                      done={false}
                      updateParent={updateTaskList}
                      deleteTask={null}
                    />
                  ))
                : null}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={closeModal} mr={3}>
              Submit
            </Button>
            <Button onClick={handleClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Text fontSize="4xl" fontWeight="bold">
        Dashboard
      </Text>
      <Text fontSize="lg">Welcome {user.displayName} 👋</Text>
      <Text fontSize="2xl" pt={8} pb={4}>
        Current Sessions
      </Text>
      <Grid templateColumns="repeat(5, 1fr)" gap={4}>
        {!sessions
          ? null
          : Object.entries(sessions).map(([key, value]) => {
              if (value.active === true) {
                return (
                  <SessionCard
                    key={key}
                    id={key}
                    name={value.name}
                    users={value.users}
                    usernames={value.usernames}
                    userPictures={value.userPictures}
                    user={user}
                    uid={uid}
                    db={db}
                  />
                );
              }
              return null;
            })}
      </Grid>

      <Text fontSize="2xl" pt={8} pb={4}>
        Create a New Session
      </Text>
      <form onSubmit={newSession}>
        <FormControl w="300px" isInvalid={isInvalid}>
          <HStack>
            <Input
              type="text"
              placeholder="New Session Name"
              value={input}
              onChange={handleInputChange}
              required
            />
            <Button colorScheme="twitter" type="submit">
              Create
            </Button>
          </HStack>
          <FormErrorMessage>Session Name is required</FormErrorMessage>
        </FormControl>
      </form>
    </Box>
  );
}

export default Home;
